/**
 * @file useScrollAnimation.js
 * @description Custom hook for scroll-triggered animations
 */

import { useEffect, useRef } from 'react';

const useScrollAnimation = () => {
  const elementRef = useRef(null);

  useEffect(() => {
    const currentElement = elementRef.current;
    if (!currentElement) return;

    // Check if element is already in viewport on mount
    const rect = currentElement.getBoundingClientRect();
    const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (isInViewport) {
      // If already visible, add visible class immediately
      currentElement.classList.add('visible');
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    observer.observe(currentElement);

    return () => {
      observer.unobserve(currentElement);
    };
  }, []);

  return elementRef;
};

export default useScrollAnimation;
